import React, { useMemo } from 'react';
import { ActionIcon, Button, TextInput } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useServerSettings } from './useServerSettings';
import { IcapServerDto } from '@/services/api/dlpSettingsApiArea/types';
import classes from './styles.module.css';

interface ServerSettingsProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  server?: IcapServerDto;
  onSuccess(server: IcapServerDto): void;
}

export const ServerSettings = ({ setIsOpen, server, onSuccess }: ServerSettingsProps) => {
  const { t } = useTranslation();
  const onClose = () => setIsOpen(false);
  const [form, handleSubmit] = useServerSettings({ server, onClose, onSuccess });

  const title = useMemo(() => (server ? t('dlp.server.edit') : t('dlp.server.add')), [server, t]);
  const submitLabel = useMemo(
    () => (server ? t('dlp.server.updateButton') : t('dlp.server.saveButton')),
    [server, t]
  );

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.title}>{title}</div>
        <ActionIcon onClick={onClose}>
          <IconX size={16} />
        </ActionIcon>
      </div>
      <div className={classes.body}>
        <TextInput
          label={t('dlp.server.host')}
          placeholder={t('dlp.server.hostPlaceholder')}
          {...form.getInputProps('Host')}
        />
        <TextInput
          label={t('dlp.server.port')}
          placeholder={t('dlp.server.portPlaceholder')}
          type="number"
          {...form.getInputProps('Port')}
        />
        <TextInput
          label={t('dlp.server.respmodService')}
          placeholder={t('dlp.server.respmodPlaceholder')}
          {...form.getInputProps('RespmodService')}
        />
        <TextInput
          label={t('dlp.server.reqmodService')}
          placeholder={t('dlp.server.reqmodPlaceholder')}
          {...form.getInputProps('ReqmodService')}
        />
      </div>
      <div className={classes.footer}>
        <Button
          fullWidth
          size="sm"
          radius={8}
          disabled={Object.keys(form.errors).length > 0}
          onClick={handleSubmit}
        >
          {submitLabel}
        </Button>
        <Button fullWidth size="sm" color="grey" radius={8} variant="light" onClick={onClose}>
          {t('dlp.server.cancelButton')}
        </Button>
      </div>
    </div>
  );
};
